import React from 'react';
import { PAGE_SIZES } from '../hooks/useTableControls';

export default function Pagination({
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
  totalPages,
  pageStart,
  pageEnd,
  total,
  paginationItems,
}) {
  if (total === 0) return null;

  return (
    <footer className="pagination-bar">
      <label className="page-size-select">
        <span>Rows per page</span>
        <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
          {PAGE_SIZES.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </label>

      <div className="page-range">
        Showing {pageStart + 1}–{pageEnd} of {total}
      </div>

      <nav className="page-controls">
        <button
          type="button"
          className="page-arrow"
          onClick={() => setCurrentPage((p) => p - 1)}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          ‹
        </button>
        {paginationItems.map((item) =>
          typeof item === 'number' ? (
            <button
              key={item}
              type="button"
              className={`page-number${currentPage === item ? ' active' : ''}`}
              onClick={() => setCurrentPage(item)}
            >
              {item}
            </button>
          ) : (
            <span key={item} className="page-ellipsis">…</span>
          )
        )}
        <button
          type="button"
          className="page-arrow"
          onClick={() => setCurrentPage((p) => p + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next page"
        >
          ›
        </button>
      </nav>
    </footer>
  );
}
